import { fetchRequest } from '@tk/utilities/tk.fetch';
import TKPrice from '@tk/components/tk.price';
import render from '@tk/utilities/tk.render';

const QUANTITY_ATTR = 'data-quantity';

export default class DIWPrice extends TKPrice {
    quantity?: number;
    requestURL?: string;

    static observedAttributes = [QUANTITY_ATTR];

    constructor() {
        super();

        this.quantity = Number(this.getAttribute(QUANTITY_ATTR)) || undefined;
        this.requestURL = this.getAttribute('data-tk-request-url') || undefined;
    }

    connectedCallback(): void {
        if (!this.requestURL) return;

        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this,
        };

        this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (name === QUANTITY_ATTR) {
            const quantity = Number(newValue);
            this.quantity = quantity;
            this.handlePrice();
        }
    }

    handlePrice() {
        const data = {
            quantity: String(this.quantity || 1),
        };

        fetchRequest({
            requestURL: this.requestURL!,
            resolveHandler: this.updatePrice.bind(this),
            payload: data,
        });
    }

    updatePrice(response: TKResponse) {
        const priceElement = render(response.dataAsHtml);
        if (priceElement.querySelector('[data-tk-price-promotion]')) this.classList.add(this.isPromotionClassName);
        this.innerHTML = priceElement.innerHTML;
    }
}
